import DestacatInformatiu from './DestacatInformatiu';
import DestacatInformatiuSkeleton from './DestacatInformatiu.skeleton';

export default function Component(props) {
    const { isLoading } = props;
    return isLoading ? <DestacatInformatiuSkeleton {...props} /> : <DestacatInformatiu {...props} />;
}
